import { Card, CardContent } from '@/components/ui/card';
import { Users, Clock, TrendingUp, UserCheck } from 'lucide-react';

interface TeamStatsProps {
  members: Array<{
    status: string;
    stats?: {
      total_hours: number;
      utilization: number;
    };
  }>;
}

const TeamStats = ({ members }: TeamStatsProps) => {
  const activeMembers = members.filter((m) => m.status === 'active').length;
  const totalHours = members.reduce((sum, m) => sum + (m.stats?.total_hours || 0), 0);
  const avgUtilization = members.length
    ? Math.round(
        members.reduce((sum, m) => sum + (m.stats?.utilization || 0), 0) / members.length
      )
    : 0;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">Total Members</p>
              <p className="text-2xl font-bold mt-1">{members.length}</p>
            </div>
            <div className="p-3 bg-blue-500/10 rounded-lg">
              <Users className="h-6 w-6 text-blue-500" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">Active Members</p>
              <p className="text-2xl font-bold mt-1">{activeMembers}</p>
            </div>
            <div className="p-3 bg-green-500/10 rounded-lg">
              <UserCheck className="h-6 w-6 text-green-500" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">Total Hours</p>
              <p className="text-2xl font-bold mt-1">{totalHours}h</p>
            </div>
            <div className="p-3 bg-purple-500/10 rounded-lg">
              <Clock className="h-6 w-6 text-purple-500" />
            </div>
          </div>
        </CardContent>
      </Card>

      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-between">
            <div>
              <p className="text-sm text-muted-foreground">Avg Utilization</p>
              <p className="text-2xl font-bold mt-1">{avgUtilization}%</p>
            </div>
            <div className="p-3 bg-orange-500/10 rounded-lg">
              <TrendingUp className="h-6 w-6 text-orange-500" />
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default TeamStats;
